import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { getNextRepayment } from '../../../repaymentScheduleSelectors';
import { REQUEST_CHANGE_ROUTER } from '../../../../../iwRouter/IwRouter.actions';
import CollapsibleSection from '../../../../ui/CollapsibleSection/CollapsibleSection';
import styles from './RepayEarly.module.css';
import { RootState } from '@iwProvider/configureStore';
import { Account } from '../../Dashboard.types';
import { FormattedDate } from 'react-intl';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';

const mapStateToProps = (
    state: RootState,
    { account }: { account: Account }
) => {
    const nextRepayment = getNextRepayment(state, account);

    return {
        nextRepaymentAmount: nextRepayment.total,
        nextRepaymentDate: nextRepayment.date,
        accountId: account.account_id
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToEarlyRepayment: (accountId: string) => {
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/repayment/choose-amount/',
                search: `?accountId=${accountId}`
            }
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const RepayEarly = ({
    nextRepaymentAmount,
    nextRepaymentDate,
    goToEarlyRepayment,
    accountId
}: PropsFromRedux) => {
    if (!accountId) return null;

    return (
        <CollapsibleSection
            data-testid="repay-early-section"
            title="Make a payment"
            isCollapsible={true}
            isInitiallyOpen={false}
        >
            <div
                className={styles.explanation}
                data-testid="repay-early-explanation"
            >
                Your next automatic payment of{' '}
                <FormattedCurrency
                    className={styles.explanationAmount}
                    value={nextRepaymentAmount}
                />{' '}
                will be on{' '}
                {<FormattedDate value={new Date(nextRepaymentDate)} />}. You can
                make a payment here any time with no extra fees.
            </div>

            <button
                data-testid="repay-early-cta"
                className={styles.cta}
                onClick={() => goToEarlyRepayment(accountId)}
            >
                Make a payment
            </button>
        </CollapsibleSection>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(RepayEarly);
